import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import '../Workflow.scss'
import { useSelector, useDispatch } from 'react-redux'
import HrbTranslate from '../../../../../components/language/HrbTranslate'
import Lang from '../../../../../components/language/services/Lang'
import WorkflowTask from '../../../../../components/library/workflow-tasks/WorkflowTask'
import { useTaskStatus } from '../../hooks/useTaskStatusHook';
import { WorkflowTasks } from '../../../services/WorkflowTasks';
import WorkflowTaskDescriptionWithHelp from '../../../../../components/library/workflow-tasks/WorkflowTaskDescriptionWithHelp';
import Button from '../../../../../components/library/buttons/Button';
import PrepareAdditionalRteDocuments from './PrepareAdditionalRteDocuments';
import { TaskStatus } from '../../../services/TaskStatus';
import TaskErrorText from '../../../../../components/library/workflow-tasks/TaskErrorText';
import PrepareReturnApi from '../../../../../services/api/prepareReturnApi';
import PrepareService from '../../../services/prepare/PrepareService';
import TicketActions from '../../../../../store/ticketRedux';
import { createInProgressTaskCompletionObject, createPrepareCompleteRequestPayload } from '../../../services/prepare/PrepareUtils';
import { useWorkflowState } from '../../hooks/useWorkflowStateHook';
import WorkflowTaskResetModal from '../../../../../components/library/workflow-tasks/WorkflowTaskResetModal';
import { useInterviewInfo } from '../../hooks/useInterviewInfoHook';
import { useTicketState } from '../../hooks/useTicketStateHook';
import { trackEvent, HeapEvents } from '../../../../../services/util/AnalyticsUtil';
import ExtraMissingFilesError from './ExtraMissingFilesError';
import DoxExplorer from '../../dox/Explorer/doxExplorer';
import DoxUploader from '../../dox/Uploader/doxUploader';
import LoadingTextValue from '../../../../../components/library/layout/LoadingTextValue';
import classnames from 'classnames';
import ToggleButton from '../../../../../components/library/buttons/ToggleButton';
import { isNull } from 'lodash';
import { supportsDocumentReview } from 'strategies/TicketTypeStrategy';


const PrepareReturnRteTask = (props) => {
    const ticketIsOpen = useTicketState(props.ticket);
    const [baseStatus, completions] = useTaskStatus(props.ticket, [WorkflowTasks.RETURN_PREPARED]);
    const ticketSupportsDocumentReview = supportsDocumentReview(props.ticket?.ticketType.identifier);
    const [interviewStatus] = useTaskStatus(props.ticket, [WorkflowTasks.INTERVIEW_COMPLETED]);
    const [documentReviewStatus] = useTaskStatus(props.ticket, [WorkflowTasks.DOCUMENT_REVIEW]);
    const [preparePaymentStatus] = useTaskStatus(props.ticket, [WorkflowTasks.PAYMENT_PREPARED]);
    const stateTasks = useWorkflowState(props.ticket);
    const [returnType, , province, primaryName, spouseName] = useInterviewInfo(props.ticket)
    const dispatch = useDispatch();
    const language = useSelector(state => state.layout.lang);
    const [uploaderOpen, setUploaderOpen] = useState(false);
    const [explorerShowing, setExplorerShowing] = useState(false);
    const [hasUploadedFiles, setHasUploadedFiles] = useState(false);
    const [status, setStatus] = useState(TaskStatus.NOT_STARTED);
    const [isCompleting, setIsCompleting] = useState(false);
    const [hasCompletionError, setHasCompletionError] = useState(false);
    const [resetModalShowing, setResetModalShowing] = useState(false);
    const [missingFiles, setMissingFiles] = useState(null);
    const [extraFiles, setExtraFiles] = useState(null);
    const [completionErrorType, setCompletionErrorType] = useState(null);
    const [primaryPomEligible, setPrimaryPomEligible] = useState(null);
    const [spousePomEligible, setSpousePomEligible] = useState(null);
    const [pOMEligibiltySelected, setPOMEligibiltySelected] = useState(false);
    const prepareReturnApi = PrepareReturnApi.create();

    useEffect(() => {
        var validCompletion = (completions || []).find(x => x.status !== TaskStatus.INVALID);
        if (validCompletion) {
            var compData = validCompletion.completionData ? JSON.parse(validCompletion.completionData) : {};
            setHasUploadedFiles(compData ? compData.hasUploadedFiles : false)
            setPrimaryPomEligible(compData.primaryPomEligible !== undefined ? compData.primaryPomEligible === true && props.isPOMEligible ? 'yes' : 'no' : null);
            setSpousePomEligible(compData.spousePomEligible !== undefined ? compData.spousePomEligible === true && props.isPOMEligible ? 'yes' : 'no' : null);
        }
    }, [props.isPOMEligible])

    useEffect(() => {
        var bStatus = baseStatus;
        
        if (ticketSupportsDocumentReview) {
            if (documentReviewStatus !== TaskStatus.COMPLETE) {
                bStatus = TaskStatus.NOT_STARTED;
            } else if (baseStatus !== TaskStatus.COMPLETE && (stateTasks || []).find(st => st.identifier === WorkflowTasks.RETURN_PREPARED)) {
                bStatus = TaskStatus.IN_PROGRESS;
            }
        } else {
            if (baseStatus !== TaskStatus.COMPLETE && (stateTasks || []).find(st => st.identifier === WorkflowTasks.RETURN_PREPARED)) {
                bStatus = TaskStatus.IN_PROGRESS
            }
        }
        
        setStatus(hasCompletionError ? TaskStatus.ERROR : bStatus);
    }, [baseStatus, stateTasks, hasCompletionError, ticketSupportsDocumentReview, documentReviewStatus])

    useEffect(() => {
        if(returnType === 'coupled' ? (!isNull(primaryPomEligible) && !isNull(spousePomEligible)) : !isNull(primaryPomEligible)) {
            setPOMEligibiltySelected(true);
        } 
    }, [primaryPomEligible, spousePomEligible])

    const createLink = (urlKey, titleKey) => (
        <a href={Lang.getCurrentValue(urlKey)} target='_blank' rel='noreferrer noopener'>
            <HrbTranslate text={titleKey} />
        </a>
    )

    const createResetLink = () => (
        <a onClick={handleShowModal}><HrbTranslate text='PrepareTask.Step4ResetLinkText' /></a>
    )

    const showUploader = () => {
        setUploaderOpen(true)
    }

    const saveCompletion = async (payload) => {
        if (props.ticket) {
            var response = await prepareReturnApi.updatePrepareReturnTask(props.ticket.id, payload)
            if (response && response.ok) {
                dispatch(TicketActions.getTicket(props.ticket.id))
            }
        }
        setIsCompleting(false);
    }

    const onSavePending = () => {
        setIsCompleting(true)
    }

    const onCloseUploader = () => {
        setUploaderOpen(false);
    }

    const onUploadsComplete = async (filesWereUploaded) => {
        if (filesWereUploaded) {
            setHasUploadedFiles(true);

            var payload = createInProgressTaskCompletionObject(
                (completions || []).find(x => x.status !== TaskStatus.INVALID), null, true);
            saveCompletion(payload);
        }

        setUploaderOpen(false);
    }

    const handleReviewAction = async () => {
        setIsCompleting(true)
        setHasCompletionError(false);
        var hasT1032File = false;
        var payload = createPrepareCompleteRequestPayload(primaryPomEligible, spousePomEligible);
        var response = await PrepareService.completePrepareTask(props.ticket.id, payload);
        if (response) {
            if (response.status) {
                dispatch(TicketActions.getTicket(props.ticket.id))
                trackEvent(HeapEvents.COMPLETE_PREPARE_RETURN, props.ticket.id)
            } else {
                setMissingFiles(response.missingFiles)
                setExtraFiles(response.extraFiles)
                if (response.missingFiles && response.extraFiles) {
                    hasT1032File = response.missingFiles.some(file => file.file_name_en?.includes('T1032') || file.file_name_fr?.includes('T1032')) &&
                        response.extraFiles.some(file => file?.includes('T1032'));
                }
                
                if (response.missingFiles && response.extraFiles && hasT1032File) {
                    setCompletionErrorType('t1032FileMismatch')
                } else if (response.missingFiles && response.extraFiles && !hasT1032File) {
                    setCompletionErrorType('both')
                } else if (response.missingFiles) {
                    setCompletionErrorType('missing')
                } else if (response.extraFiles) {
                    setCompletionErrorType('extra')
                } else {
                    setCompletionErrorType(null)
                }
                setHasCompletionError(true)
            }
        } else {
            setMissingFiles(null)
            setExtraFiles(null)
            setCompletionErrorType(null)
            setHasCompletionError(true)
        }
        setIsCompleting(false)
    }

    const handleReset = async () => {
        var response = await PrepareService.resetPrepareTask(props.ticket.id);
        if (response) {
            setHasUploadedFiles(false);
            setPOMEligibiltySelected(false);
            if (props.isPOMEligible) {
                setPrimaryPomEligible(null);
                setSpousePomEligible(null);
            }
            else {
                setPrimaryPomEligible('no');
                setSpousePomEligible('no');
            }
            dispatch(TicketActions.getTicket(props.ticket.id))
            trackEvent(HeapEvents.PREPARE_RETURN_RESET, props.ticket.id)
        }

        handleHideModal();
    }

    const handleShowModal = () => {
        setResetModalShowing(true);
    }

    const handleHideModal = () => {
        setResetModalShowing(false);
    }

    const showExplorer = () => {
        setExplorerShowing(true)
    }

    const onExplorerClose = () => {
        setExplorerShowing(false)
    }

    const primaryPOMToggle = value => {
        setPrimaryPomEligible(value)
    }

    const spousePOMToggle = value => {
        setSpousePomEligible(value)
    }
    return (
        <WorkflowTask status={status} taskId={WorkflowTasks.RETURN_PREPARED}>
            {!ticketSupportsDocumentReview && (
                <Fragment>
                    <div className='columns'>
                        <WorkflowTaskDescriptionWithHelp
                            helpKey='0ProSupport/VDOPro/Prepare.htm'
                            descriptions={['PrepareTask.RteTaskStep1']}
                            classNames='p1 medium-weight'
                        />
                    </div>
                    <div className='columns prep-section'>
                        <div className='column is-offset-1 is-8'>
                            <p className='p2'>
                                <HrbTranslate text={province === 'QC' ? 'PrepareTask.RteTaskStep1DescQC1' : 'PrepareTask.RteTaskStep1Desc1'}
                                    params={{
                                        RepAClient: createLink('PrepareTask.RteDesc1Link1', 'PrepareTask.RteDesc1Param1'),
                                    }} />
                            </p>
                            <br/>
                            <p className='p2'>
                                <HrbTranslate text={province === 'QC' ? 'PrepareTask.RteTaskStep1DescQC2' : 'PrepareTask.RteTaskStep1Desc2'}
                                    params={{
                                        RACErrorWorkarounds: createLink('PrepareTask.RteDesc1Link2', 'PrepareTask.RteDesc1Param2'),
                                    }} />
                            </p>
                            <br/>
                            <p className='p2'>
                                <HrbTranslate text={province === 'QC' ? 'PrepareTask.RteTaskStep1DescQC3' : 'PrepareTask.RteTaskStep1Desc3'}/>
                            </p>
                        </div>
                    </div>
                    <div className='columns'>
                        <div className='column is-offset-1 is-10'>
                            <div className='prep-border' />
                        </div>
                    </div>
                </Fragment>
            )}
            <div className='columns '>
                <div className='column is-offset-1 is-10'>
                    <p className='p1 medium-weight'><HrbTranslate text={ticketSupportsDocumentReview ? 'PrepareTask.RtedrTaskStep1' : 'PrepareTask.RteTaskStep2'} /></p>
                    <p className='p2 step-content'><HrbTranslate text='PrepareTask.RteTaskStep2Desc1' /></p>
                    <p className='p2 step-content'>
                        <HrbTranslate text={province === 'QC' ? 'PrepareTask.RteTaskStep2Desc2QC' : 'PrepareTask.RteTaskStep2Desc2'} />
                    </p>
                    <p className='p2 step-content'>
                        <HrbTranslate text={ticketSupportsDocumentReview ? 'PrepareTask.RteTaskStep2Desc3' : 'PrepareTask.RteTaskStep2Desc3Rte'} 
                            params={{
                                FileNamingConvention: createLink('PrepareTask.FileNamingConventionLink', 'PrepareTask.FileNamingConvention')
                            }} />
                    </p>
                    {props.ticket &&
                        <Fragment>
                            <div className='step-center-container'>
                                <Button
                                    elementId='prepare-manage-btn'
                                    labelKey='DocUploadTask.ViewManage'
                                    buttonStyles='secondary'
                                    onClick={showExplorer}
                                    disabled={baseStatus === TaskStatus.COMPLETE || !ticketIsOpen || (ticketSupportsDocumentReview && documentReviewStatus !== TaskStatus.COMPLETE)}
                                />
                                <Button
                                    elementId='prepare-upload-btn'
                                    labelKey='PrepareTask.UploadDocs'
                                    buttonStyles='secondary'
                                    onClick={showUploader}
                                    disabled={baseStatus === TaskStatus.COMPLETE || !ticketIsOpen || (ticketSupportsDocumentReview && documentReviewStatus !== TaskStatus.COMPLETE)}
                                />
                            </div>
                        </Fragment>
                    }
                    <div className='prep-border' />
                </div>
            </div>
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-10'>
                    <p className='p1 medium-weight'><HrbTranslate text={ticketSupportsDocumentReview ? 'PrepareTask.RtedrTaskStep2' : 'PrepareTask.RteTaskStep3'} /></p>
                </div>
            </div>
            <PrepareAdditionalRteDocuments ticket={props.ticket} onSaveCompletion={saveCompletion}
                hasUploadedFiles={hasUploadedFiles} disabled={!ticketIsOpen} onSavePending={onSavePending} />
            { props.isPOMEligible &&
                <>
                    <div className='columns prep-section'>
                        <div className='column is-offset-1 is-10'>
                            <div className='prep-border' />
                        </div>
                    </div>
                    <div className='columns prep-section'>
                        <div className='column is-offset-1 is-10'>
                            <p className='p1 medium-weight'><HrbTranslate text={ticketSupportsDocumentReview ? 'PrepareTask.RtedrStep3' : 'PrepareTask.RteStep4'} /></p>
                            <p className='p2 step-content'><HrbTranslate text='PrepareTask.RteTaskStep4Desc1' /></p>
                        </div>
                    </div>
                    <div className='columns prep-section'>
                        <div className={classnames('column is-offset-1', { 'is-5': returnType === 'coupled', 'is-10': returnType !== 'coupled' })}>
                            <h4><LoadingTextValue value={primaryName} /></h4>
                            <p className='p2 step-content'>
                                <HrbTranslate text='PrepareTask.RteTaskStep4Desc2'
                                    params={{ productName: language == "en" ? "Peace of Mind" : "Tranquillité d'esprit" }} />
                            </p>
                            <ToggleButton elementId={status !== TaskStatus.COMPLETE ? 'pom-toggle-active' : 'pom-toggle-disabled'}
                                value={primaryPomEligible} options={['Yes', 'No']} labels={['App.Yes', 'App.No']} onChange={primaryPOMToggle} />
                        </div>
                        {returnType === 'coupled' &&
                            <div className='column is-5'>
                                <h4><LoadingTextValue value={spouseName} /></h4>
                                <p className='p2 step-content'>
                                    <HrbTranslate text='PrepareTask.RteTaskStep4Desc2'
                                        params={{ productName: language == "en" ? "Peace of Mind" : "Tranquillité d'esprit" }} />
                                </p>
                                <ToggleButton elementId={status !== TaskStatus.COMPLETE ? 'pom-toggle-active' : 'pom-toggle-disabled'}
                                    value={spousePomEligible} options={['Yes', 'No']} labels={['App.Yes', 'App.No']} onChange={spousePOMToggle} />
                            </div>
                        }
                    </div>
                </>
            }
            {ticketSupportsDocumentReview && (
                <>
                    <div className='columns prep-section'>
                        <div className='column is-offset-1 is-10'>
                            <div className='prep-border' />
                        </div>
                    </div>
                    <div className='columns prep-section'>
                        <div className='column is-offset-1 is-10'>
                            <p className='p1 medium-weight'><HrbTranslate text='PrepareTask.RtedrStep4' /></p>
                            <p className='p2 step-content'>
                                <HrbTranslate text='PrepareTask.RtedrTaskStep4Desc1'
                                    params={{
                                        UtpCalculator: createLink('DocumentReviewTask.UpfrontPricingCalculatorLink', 'DocumentReviewTask.UpfrontPricingCalculator')
                                    }} />
                            </p>
                            <p className='p2 step-content'>
                                <HrbTranslate text='PrepareTask.RtedrTaskStep4Desc2'
                                    params={{
                                        ClientReviewTemplate: createLink('PrepareTask.ClientReviewTemplateUrl', 'PrepareTask.ClientReviewTemplateLink')
                                    }} />
                            </p>
                            <p className='p2 step-content'><HrbTranslate text='PrepareTask.RtedrTaskStep4Desc3' /></p>
                        </div>
                    </div>
                </>
            )}
            {!ticketSupportsDocumentReview && (
                <>
                    <div className='columns prep-section'>
                        <div className='column is-offset-1 is-10'>
                            <div className='prep-border' />
                        </div>
                    </div>
                    <div className='columns prep-section'>
                        <div className='column is-offset-1 is-10'>
                            <p className='p1 medium-weight'><HrbTranslate text='PrepareTask.RteStep5' params={{ stepNumber: props.isPOMEligible ? 5 : 4 }} /></p>
                            <p className='p2 step-content'>
                                <HrbTranslate text={'PrepareTask.RteTaskStep5Desc'}
                                    params={{ MsgTemplate: createLink('PrepareTask.DescLink3', 'PrepareTask.DescParam3') }} />
                            </p>
                        </div>
                    </div>
                </>
            )}
            <div className='columns'>
                <div className='column is-offset-1 is-10'>
                    {props.ticket &&
                        <div className='step-center-container'>
                            <Button
                                elementId='prepare-done-btn'
                                labelKey='PrepareTask.Step4ReviewBtn'
                                buttonStyles='primary'
                                onClick={handleReviewAction}
                                disabled={baseStatus === TaskStatus.COMPLETE || !hasUploadedFiles || interviewStatus !== TaskStatus.COMPLETE || !ticketIsOpen || (props.isPOMEligible && !pOMEligibiltySelected) || (ticketSupportsDocumentReview && documentReviewStatus !== TaskStatus.COMPLETE)}
                                loading={isCompleting}
                            />
                        </div>
                    }
                    {hasCompletionError && !completionErrorType &&
                        <TaskErrorText errorKey='PrepareTask.ErrorSubmit' />
                    }
                    {hasCompletionError && completionErrorType &&
                        <ExtraMissingFilesError completionErrorType={completionErrorType}
                            extraFiles={extraFiles} missingFiles={missingFiles} task='prepare' />
                    }
                    <WorkflowTaskResetModal
                        isOpen={resetModalShowing} status={TaskStatus.IN_PROGRESS} onCancel={handleHideModal}
                        onReset={handleReset} titleKey="PrepareTask.ResetModal.Title"
                        resetButtonKey="PrepareTask.ResetModal.Btn"
                        contentKeys={['PrepareTask.ResetModal.Content']} />
                    {baseStatus === TaskStatus.COMPLETE && ticketIsOpen && preparePaymentStatus !== TaskStatus.COMPLETE &&
                        <p className='p2 step-content'>
                            <HrbTranslate text='PrepareTask.Step4Reset' params={{ ResetLink: createResetLink() }} />
                        </p>
                    }
                </div>
            </div>
            <DoxExplorer ticket={props.ticket} show={explorerShowing}
                onClose={onExplorerClose}
            />
            <DoxUploader ticket={props.ticket} show={uploaderOpen}
                layoutType={'desktop'} onUploadsComplete={onUploadsComplete} onClose={onCloseUploader}
            />
        </WorkflowTask>
    );
}

PrepareReturnRteTask.whyDidYouRender = false;

PrepareReturnRteTask.propTypes = {
    ticket: PropTypes.object,
    isPOMEligible: PropTypes.bool
}

export default PrepareReturnRteTask